import { render, staticRenderFns } from "./shjdFooter.vue?vue&type=template&id=97758390&scoped=true"
import script from "./shjdFooter.vue?vue&type=script&lang=js"
export * from "./shjdFooter.vue?vue&type=script&lang=js"
import style0 from "./shjdFooter.vue?vue&type=style&index=0&id=97758390&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97758390",
  null
  
)

export default component.exports